import * as React from 'react';

import {CreateLeadSummaryNotePage} from './create-lead-summary-note';
import {FindPotentialContactsPage} from './find-potential-contacts';
import type {InteractionData} from './types';

export function getModalHeaderText(data: InteractionData): string {
    switch (data.__typename) {
        case 'FindPotentialContactsData':
            return '✨ Lead research agent';
        case 'LeadSummaryData':
            return '✨ Your lead research report';
        default:
            return '';
    }
}

export function getSubHeaderText(data: InteractionData): string {
    switch (data.__typename) {
        case 'FindPotentialContactsData':
            return 'We found people that might belong to this lead. You can choose to add them as additional contacts.';
        case 'LeadSummaryData':
            return 'Review this report for accuracy and save it as a note for quick reference.';
        default:
            return '';
    }
}

export function getInteractionComponent(data: InteractionData, onCancel: () => void) {
    switch (data.__typename) {
        case 'FindPotentialContactsData':
            return <FindPotentialContactsPage data={data} onCancel={onCancel} />;
        case 'LeadSummaryData':
            return <CreateLeadSummaryNotePage data={data} onCancel={onCancel} />;
        default:
            return null;
    }
}
